export default __webpack_public_path__ + "static/media/minibox_tiger.e7755de8.png";